<template>
    <div class="button-back-box" @click="onGoback()">
        <img :src="require(`@/public/img/${$store.state.config.skin}/chevron.png`)" />
        <span>{{ getTranslatedText('back') }}</span>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],
    props: {
        isEmitGoBack: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onGoback() {
            if (this.isEmitGoBack) {
                this.$emit('on-click-go-back');
            } else {
                this.$router.go(-1);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/buttonBack.scss';
</style>
